import axios from "axios";
import store from "@/store";
import { bus } from './bus';
import { Message } from 'element-ui';

let http = axios.create({
  baseURL: "https://fanpdf.com/index.php/api",
  timeout: 60 * 10 * 1000,
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    if(config.data){
      config.data.app_id = '10001';
      config.data.token = window.localStorage.getItem("token");
    }else{
      config.data = {};
      config.data.app_id = '10001';
      config.data.token = window.localStorage.getItem("token");
    }
    return config;
  },
  (err) => {
    Message({
      message: "网络错误",
      type: "warning",
    });
  }
);

// 响应拦截器
http.interceptors.response.use(
  (Response) => {
    if (Response.data.code === -1) {
      bus.$emit('openPop',Response.data.msg)
      // 打开登录弹窗
      store.state.loginPop = true;
      return Response.data;
    } else if (Response.data.code === 0) {
      // bus.$emit('openPop',Response.data.msg)
      // // 打开登录弹窗
      // store.state.loginPop = true;
      bus.$emit('openPop',Response.data.msg)
      return Response.data;
    } else if (Response.data.code === 3) {
      bus.$emit('openPop',Response.data.msg)
      return Response.data;
    } else if (Response.data.code) {
      // bus.$emit('openPop',Response.data.msg)
      return Response.data;
    }
    console.log(Response)
  },
  (error) => {
    console.error(error, "error");
  }
);

// post请求
const post = (url, data) => http.post(url, data);
const get = (url, data) => http.get(url, {
  params:{...data}
});
const host = "fanpdf.com/";
const wssUrl = 'wss://'+host+'wss';
const baseURL = "https://fanpdf.com/index.php/";

export default { post, get, baseURL,wssUrl };
